import { Sparkles } from 'lucide-react';
import { Typography } from '../../symphony/ui';
import { useTranslation } from '../../../lib/i18n';
import { formatFreeUntil } from '../../../lib/free-usage';
import styles from './FreeUsageNotice.module.css';

/** "Free until Oct 14, 3:00 PM" — shown on the plan card while promo free hours are running. */
export function FreeUsageNotice({ untilIso }: { untilIso: string | null }) {
  const { t, i18n } = useTranslation();
  if (!untilIso) return null;
  return (
    <div className={styles.row} data-testid="settings-free-usage">
      <Sparkles className={styles.glyph} size={16} aria-hidden />
      <Typography variant="h4" component="span">
        {t('credits.freeUntil', { date: formatFreeUntil(untilIso, i18n.language) })}
      </Typography>
    </div>
  );
}
